export default {
  metrics: {
    pickup: 'Nouto',
    internal_delivery: 'Oma toimitus',
    external_delivery: 'Ulkoinen toimitus',
  },
  events: {
    add_to_basket: 'Lisää tuote',
    begin_checkout: 'Siirry kassalle',
    begin_purchase: 'Aloita maksu',
    complete_purchase: 'Viimeistele maksu',
    order_placed: 'Viimeistele maksu',
    view_item: 'Näytä tuote',
  },
};
